'use strict';

import * as Sentry from '@sentry/browser';
import React, { Component } from 'react';
import API from './API';

const sentrySpec = {
    dsn: Payload.release.dsn,
    release: Payload.release.version,
    environment: Payload.release.deploy,
};

if (Payload.release.sentry_enabled) {
    Sentry.init(sentrySpec);
}

export function ConfigureUser(username, email) {
    Sentry.configureScope((scope) => {
        scope.setUser({
            'username': username,
            'email': email,
        });
    });
}

export function ConfigureSessionTracing(sessionID) {
    Sentry.configureScope((scope) => {
        scope.setTag('sessionID', sessionID);
    });
}

export default class extends Component {
    _captureMessage() {
        Sentry.captureMessage(`Hello from ${Payload.release.platform} release ${Payload.release.version} at ${new Date().toISOString()}`);
    }
    _throw() {
        throw new Error(`${Payload.release.platform} threw this Error at ${new Date().toISOString()}`);
    }
    _throw_wrapped() {
        Sentry.captureException(new Error('${Payload.release.platform} captured this wrapped ball at ' + new Date().toISOString()));
    }
    _command_GenerateError() {
        API('GenerateError');
    }
    render() {
        if (!Payload.release.sentry_enabled) {
            return (
                <div className='sentry-check'>
                    <div>Release: {Payload.release.version}</div>
                    <div>SENTRY DISABLED</div>
                </div>
            );
        }
        
        return (
            <div className='sentry-check'>
                <div>Release: {Payload.release.version}</div>
                <div>Sentry version: {Sentry.SDK_VERSION}</div>
                {/* <div>Sentry enabled: {Sentry.BrowserClient().isEnabled()}</div> */}
                
                <button onClick={this._captureMessage}>captureMessage</button>
                <button onClick={this._throw}>throw error</button>
                <button onClick={this._throw_wrapped}>throw wrapped error</button>
                <button onClick={this._command_GenerateError}>Generate API error</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// /home/eric/projects/com.strongproject/repos/platforms/common-js/framework/Sentry.jsx